import {
  TableProps as CoreTableProps,
  Div,
  Tr,
  Td,
} from '@kizi/core-components';
import React, { useEffect, useState } from 'react';
import { IconV2 } from '@kizi/shared-components';
export interface TableAccordionRowProps extends CoreTableProps {
  labels: any[];
  rows: any[][];
  options: string[];
}

export const TableAccordionRow: React.FC<TableAccordionRowProps> = ({
  labels,
  rows,
  options,
}) => {
  const [show, setShow] = useState(false);
  const icon = show ? 'big-arrow-up' : 'big-arrow-down';

  useEffect(() => {
    if (
      options.length &&
      options.some(
        (option) =>
          labels[0].props.label === option ||
          labels[0].props.children.includes(option)
      )
    ) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [JSON.stringify(options)]);

  const tbody = show
    ? rows.map((row: React.ReactNode[], j: number) => {
        return (
          <Div key={`row-${j}`} variant="bodyRowContainer">
            {row.map((cell: React.ReactNode, k: number) => {
              return (
                <Div key={`cell-${j}-${k}`} variant="accordionChild">
                  {cell}
                </Div>
              );
            })}
          </Div>
        );
      })
    : null;

  const fontWeight = show ? { fontWeight: 'bold' } : { fontWeight: 'initial' };
  const borderColor = show
    ? {
        borderBottomLeftRadius: '0px !important',
        borderBottomRightRadius: '0px !important',
      }
    : {};
  return (
    <Tr variant="rowAccordionContainer">
      <Div variant="headRowContainer">
        {labels.map((label, i) => {
          const Cell = (props) => {
            return i === 0 ? (
              <Td variant="accordionHeader" onClick={() => setShow(!show)}>
                <Div {...props} style={fontWeight} />
                <IconV2 name={icon} width={18} height={18} marginLeft={1} />
              </Td>
            ) : (
              <Td {...props} css={borderColor} />
            );
          };
          return (
            <Cell key={`label-${i}`} variant="cellContainer">
              {label}
            </Cell>
          );
        })}
      </Div>
      {tbody}
    </Tr>
  );
};
